import { useEffect } from 'react';

export default function CTASection() {
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="contacto" className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-calendar-check-line text-3xl text-white"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-primary">
            ¿Listo para encontrar tu rumbo?
          </h2>
          <p className="text-xl text-secondary max-w-2xl mx-auto">
            Coordinemos una reunión estratégica para analizar tu situación actual
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div
            className="calendly-inline-widget"
            data-url="https://calendly.com/micaelakon-rumbomarketing/30min"
            style={{ minWidth: '320px', height: '700px' }}
          ></div>
        </div>
      </div>
    </section>
  );
}
